import styled from 'styled-components';
import { fontSizes, lineHeights } from 'syf-component-library/defaultTheme';
export const TabsList = styled.ul `
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
export const ListItem = styled.li `
  color: ${({ showActiveStyles, theme }) => showActiveStyles ? `${theme.navigation.activeTabText}` : 'inherit'};
`;
export const TabButton = styled.button `
  min-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: transparent;
  border: none;
  font-size: ${fontSizes.root}px;
  line-height: ${lineHeights.root};
  color: ${({ showActiveStyles, theme }) => showActiveStyles ? `${theme.navigation.activeTabText}` : 'inherit'};
  font-weight: ${({ showActiveStyles }) => showActiveStyles ? 'bold' : 'normal'};
  cursor: pointer;
  padding: 0;
  border-bottom: ${({ showActiveStyles, theme }) => showActiveStyles
    ? `2px solid ${theme.navigation.activeTabBorder}`
    : '2px solid transparent'};

  &:hover {
    border-bottom: ${({ theme }) => `2px solid ${theme.navigation.activeTabBorder}`};
  }
`;
